module.exports = __webpack_public_path__ + "media/images/flags/ki-f44f8acee0e3805741f77047c14918bb.svg";